import { render, staticRenderFns } from "./ForgotPasswordCsr.vue?vue&type=template&id=312f7997&scoped=true"
import script from "./ForgotPasswordCsr.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCsr.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordCsr.vue?vue&type=style&index=0&id=312f7997&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f7997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312f7997')) {
      api.createRecord('312f7997', component.options)
    } else {
      api.reload('312f7997', component.options)
    }
    module.hot.accept("./ForgotPasswordCsr.vue?vue&type=template&id=312f7997&scoped=true", function () {
      api.rerender('312f7997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgotPasswordCsr.vue"
export default component.exports